import classNames from "classnames";
import { ReactNode } from "react";

type Props = {
  label: string;
  value: ReactNode | ReactNode[];
  isHighlighted?: boolean;
  valueProps?: {
    className?: string;
  };
  parentProps?: {
    className?: string;
  };
};

const PurchaseInformationListItem = ({
  label,
  value,
  isHighlighted = false,
  valueProps,
  parentProps,
}: Props) => {
  return (
    <li className="text-md font-semibold">
      <div
        className={classNames(
          "my-3 flex text-sm sm:text-md sm:font-semibold justify-between gap-2",
          parentProps?.className
        )}
      >
        <div className="w-1/2">
          {isHighlighted && <h5>{label}</h5>}
          {!isHighlighted && <span>{label}</span>}
        </div>
        <div className={classNames("w-1/2 text-right", valueProps?.className)}>
          {isHighlighted && <h5>{value}</h5>}
          {!isHighlighted && <span>{value}</span>}
        </div>
      </div>
    </li>
  );
};

export default PurchaseInformationListItem;
